// components/navbar/constants.ts

export const generateSectionsIcons = (data) => {
    const ICONS = [
        { title: 'GUESTS', label: data.guests, image: '/assets/icons/iconos-home-10.webp', size: { width: 50, height: 50 } },
        { title: 'CABINS', label: data.cabins, image: '/assets/icons/iconos-home-11.webp', size: { width: 50, height: 50 } },
        { title: 'CREW', label: data.crews, image: '/assets/icons/iconos-home-12.webp', size: { width: 50, height: 50 } },
        { title: 'WIFI', label: 'Free onboard', image: '/assets/icons/iconos-home-13.webp', size: { width: 50, height: 50 } },
    ];

    return ICONS
}

